module.exports = __webpack_public_path__ + "img/logo.061cdf2a.png";